import { RETRIEVE_PROJECT_LIST_PENDING } from 'Constants/ProjectListing/ProjectListing.constants';

export function retrieveProjectList() {
  return {
    type: RETRIEVE_PROJECT_LIST_PENDING
  };
}
